/** Opening the resend dialog is independent of the invoice's successful-send history. */
export function cleaningPaymentResendEnabled(record) {
  return cleaningPaymentResendDisabledReason(record) === '';
}

export function cleaningPaymentResendDisabledReason(record) {
  if (record.confirmedOrderNumber?.trim()) return '注文番号が登録済みのため、請求書は再送信できません。';
  if (record.hiddenState) return '非表示の受付には請求書を再送信できません。';
  if (record.draftCreationPending) return 'Draft作成中・結果確認待ちのため再送信できません。';
  if (!record.draftOrderGid) return 'Draft Orderの作成後に利用できます。';
  return '';
}

// Shared by CS Admin's browser and CS Order's Vite bundle. Keep the same priority in both.
export const cleaningStatusStages = Object.freeze([
  '受付済み', '商品到着', 'Draft済み', '決済待ち', '決済完了', 'クリーニング中', '出荷依頼',
]);

/** Display only: do not change persisted workflow status or infer Shopify financial status. */
export function cleaningDisplayStatus(record) {
  if (record.hiddenState || ['非表示', '非表示済', '取消済み'].includes(record.processStatus)) {
    return record.processStatus;
  }
  const current = ['受付処理中', '受付済'].includes(record.processStatus) ? '受付済み' : record.processStatus;
  const rank = cleaningStatusStages.indexOf(current);
  // Cleaning/shipping operations are later than payment; payment evidence must not mask them.
  if (rank >= 5 || current === '出荷依頼済' || current === '出荷済み') return current;
  if (record.confirmedOrderNumber?.trim()) return '決済完了';
  if (rank >= 4) return current;
  if (record.hasSentPaymentInvoice === 1 || record.hasSentPaymentInvoice === true) return '決済待ち';
  return current;
}

export const cleaningStatusBadgeClasses = new Map([
  ['受付済み', 'cleaning-received-status-badge'],
  ['商品到着', 'cleaning-arrived-status-badge'],
  ['Draft済み', 'cleaning-draft-status-badge'],
  ['決済待ち', 'cleaning-payment-pending-status-badge'],
  ['決済完了', 'cleaning-payment-completed-status-badge'],
  ['クリーニング中', 'cleaning-in-progress-status-badge'],
  ['出荷依頼', 'cleaning-shipping-requested-status-badge'],
  ['出荷依頼済', 'cleaning-shipping-requested-status-badge'],
  ['取消済み', 'cleaning-cancelled-status-badge'],
]);

export function cleaningStatusBadgeClass(record) {
  const variant = cleaningStatusBadgeClasses.get(cleaningDisplayStatus(record));
  return `cleaning-status-badge${variant ? ` ${variant}` : ''}`;
}
